import { Badge, Button, Form, Modal } from 'react-bootstrap'
import { BeaconFunctionAppsRow } from '../../../common/beacon.interfaces'
import { useCallback, useEffect, useMemo, useState } from 'react'
import '../../../styles/beacon.css'
import XSvg from '../../svg/X-Svg'

interface BeaconEditFunctionAppModal {
  visible: boolean
  functionAppRow: BeaconFunctionAppsRow
  closeCallback: any
  saveCallback: any
  functionApp: string
  tags: string[]
}

export default function BeaconEditFunctionAppModal(props: BeaconEditFunctionAppModal) {
  const [clone, setClone] = useState<BeaconFunctionAppsRow | undefined>(undefined);
  const [tagText, setTagText] = useState<string | undefined>(undefined);
  const [newTag, setNewTag] = useState<string>('');

  useEffect(() => {
    if (!props.functionAppRow) return;
    setClone(JSON.parse(JSON.stringify(props.functionAppRow)));
  }, [props.functionAppRow]);

  const handleClose = useCallback(() => {
    setClone(undefined);
    setTagText(undefined);
    setNewTag('');
    props.closeCallback();
  }, []);

  const handleSave = useCallback(() => {
    if (!clone?.tags) {
      return;
    }

    props.saveCallback({
      ...props.functionAppRow,
      ...clone,
    });
    setClone(undefined);
    setTagText(undefined);
    setNewTag('');
  }, [props.functionAppRow, clone]);

  const handleTagInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewTag(e.target.value.trim().toUpperCase());
  };

  const addTag = () => {
    if (!newTag || newTag === '-- SELECT A TAG --') return;
    const tags = JSON.parse(clone?.tags ?? '[]');
    if (!tags.includes(newTag)) {
      const updatedTags = [...tags, newTag];
      setClone({ ...clone, tags: JSON.stringify(updatedTags) });
      setNewTag('');
    }
  };

  const removeTag = (tag: string) => {
    const tags = JSON.parse(clone?.tags ?? '[]').filter((t: string) => t !== tag);
    setClone({ ...clone, tags: JSON.stringify(tags) });
  };

  const handleTagSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setNewTag(e.target.value);
  };

  const view = useMemo(() => {
    const tags = JSON.parse(clone?.tags ?? '[]');
    return (
      <Modal show={props.visible} animation={false} onHide={handleClose} className='modal-xl'>
        <Modal.Header closeButton>
          <Modal.Title><span className='beacon-header'>{props.functionApp?.toUpperCase()} FUNCTION APP SETTINGS</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-wrap gap-2">
            {tags.map((t: string) => (
              <Badge bg="secondary" key={t} className="d-flex align-items-center gap-2 p-2">
                {t}
                <Button variant="outline-light" size="sm" className="p-0 border-0" onClick={() => removeTag(t)}>
                  <XSvg height={15} />
                </Button>
              </Badge>
            ))}
          </div>
          <br />
          <span className='beacon-header'>TAGS</span>

          <Form.Control type='text' value={newTag} onChange={handleTagInputChange} style={{width: '200px'}} placeholder='Enter a new tag...'/>
          <Button variant='secondary' className='mt-2' onClick={addTag}>Add Tag</Button>
          {props.tags?.length > 0 && (
            <div>
              <span className='beacon-label'>Or select a tag</span>
              <Form.Select onChange={handleTagSelectChange} value={newTag} style={{width: '200px'}}>
                <option>-- SELECT A TAG --</option>
                {props.tags?.sort()?.map(tag => (
                  <option key={tag} value={tag}>{tag}</option>
                ))}
              </Form.Select>
              <Button variant='secondary' className='mt-2' onClick={addTag}>Add Selected Tag</Button>
            </div>
          )}
          <span>{tagText}</span>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-start">
          <Button variant="success" onClick={handleSave}>SAVE</Button>
        </Modal.Footer>
      </Modal>
    );
  }, [props, clone, newTag, tagText]);

  return view;
}